"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProductListingFacets = void 0;
var _fetching = require("@ori/fetching");
var _editorialFacetsQuery = require("../queries-net/editorialFacetsQuery");
var _utils = require("../utils");
/* istanbul ignore file @preserve */ /**
 * Fetch function that fetches facets for a given pageId and facetFiltering keys
 */ const getProductListingFacets = async (param)=>{
    let { graphQlUrl, headers, pageId, facetFiltering, previewMode } = param;
    var _data_application_editorialPage, _data_application;
    const data = await (0, _fetching.fetchGraphql)({
        query: _editorialFacetsQuery.productListingFacetsQuery,
        url: graphQlUrl,
        variables: {
            pageId,
            facetFiltering
        },
        headers: {
            ...headers,
            [_fetching.PREVIEW_MODE]: previewMode !== null && previewMode !== void 0 ? previewMode : false
        },
        ...previewMode ? {
            timeout: 30000
        } : {
            timeout: 10000
        }
    });
    var _data_application_editorialPage_contentItems;
    const contentItems = (_data_application_editorialPage_contentItems = (_data_application = data.application) === null || _data_application === void 0 ? void 0 : (_data_application_editorialPage = _data_application.editorialPage) === null || _data_application_editorialPage === void 0 ? void 0 : _data_application_editorialPage.contentItems) !== null && _data_application_editorialPage_contentItems !== void 0 ? _data_application_editorialPage_contentItems : [];
    const editorialPlpRow = contentItems.find((item)=>item.__typename === 'EditorialPlpRows');
    if ((editorialPlpRow === null || editorialPlpRow === void 0 ? void 0 : editorialPlpRow.__typename) === 'EditorialPlpRows') {
        return (0, _utils.mapFacetFilterFromApi)(editorialPlpRow.content.facets);
    }
    return [];
};
exports.getProductListingFacets = getProductListingFacets;
